// Gatsby requirements
import React, { useState } from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'

// Styles
import * as CSS from './sectionPricingCards.module.scss'

const SectionPricingCards = ({ blok }) => {

    const [openMore, setOpenMore] = useState(false)

    return (
        <section 
            className={CSS.section}
            id={blok.anchorId}
            style={{
                backgroundColor: blok.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null
            }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">

                {blok.richtext &&
                    <div className={CSS.richtext}>
                        <RichTextRenderer data={blok.richtext} />
                    </div>
                }

                {blok.enableSwitchButton === true &&
                    <>
                    <div className={CSS.toggle}>
                        <span style={{color: openMore === false ? '#000' : '#777777'}}>{blok.textForSwitchOff}</span>
                        <input 
                            type="checkbox"
                            id={'toggle-'+blok._uid}
                            onClick={() =>
                                openMore === true
                                ? setOpenMore(false)
                                : setOpenMore(true)
                            }
                        />
                        <label for={'toggle-'+blok._uid}>Toggle between {blok.textForSwitchOff} and {blok.textForSwitchOn}</label>
                        <span style={{color: openMore === true ? '#000' : '#777777'}}>{blok.textForSwitchOn}</span>
                    </div>
                    <div className={CSS.cards} style={{display: openMore === false ? 'flex' : 'none'}}>
                        {blok.cards.map(card => (
                            <div
                                className={CSS.card}
                                style={{
                                    backgroundColor: blok.backgroundColor === '#f1f1ef' ? '#fff' : '#f1f1ef',
                                }}
                            >
                                {card.richtext &&
                                    <RichTextRenderer data={card.richtext} />
                                }
                            </div>
                        ))}
                    </div>
                    </>
                }

                <div className={CSS.cards} style={{display: openMore === true ? 'flex' : 'none'}}>
                    {blok.cardsAfterSwitch.map(card => (
                        <div 
                            className={CSS.card}
                            style={{
                                backgroundColor: blok.backgroundColor === '#f1f1ef' ? '#fff' : '#f1f1ef',
                            }}
                        >

                            {card.richtext &&
                                <RichTextRenderer data={card.richtext} />
                            }

                        </div>
                    ))}
                </div>

                <div className={CSS.logos}>
                    {blok.logosAfterCards.map(card => (
                        <img
                            src={card.filename}
                            loading="lazy"
                            width={card.filename.split('/')[5].split('x')[0]}
                            height={card.filename.split('/')[5].split('x')[1]}
                            alt={card.alt}
                        />
                    ))}
                </div>

            </div>

        </section>
    )
}

export default SectionPricingCards